import { render, staticRenderFns } from "./schedule-component.vue?vue&type=template&id=6a23721e&scoped=true&lang=pug"
import script from "./schedule-component.js?vue&type=script&lang=js&external"
export * from "./schedule-component.js?vue&type=script&lang=js&external"
import style0 from "./schedule-component.vue?vue&type=style&index=0&id=6a23721e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a23721e",
  null
  
)

export default component.exports